import { call, put } from 'redux-saga/effects';
import { ApiError } from 'store/api/types';
import { FetchContactRequestAction } from '../types';
import { checkResponse } from 'store/utils';

import { GetContactResponse, getContact } from '../api';
import { turnMessageOn } from 'store/app/actions';
import { MessageData } from 'store/app/types';
import { MessageStates } from 'containers/MessageBox';

import { fetchContactFailure, fetchContactSuccess } from '../actions';
import { logoutRequest } from 'store/auth/actions';
import { renderErrorMessage } from 'utils/render-error-message';
import i18n from 'i18next';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* fetchContactSaga(action: FetchContactRequestAction) {
  try {
    let err: ApiError | null;
    const { contactUuid, connectionId } = action.payload;

    const response: GetContactResponse = yield call(getContact, connectionId, contactUuid);
    err = checkResponse(response?.responseMessage);
    if (err) throw err;

    const viesChecks = response.data.viesChecks;
    const contact = response.data.contact;

    if (viesChecks.length > 0)
      yield put(fetchContactSuccess(viesChecks, contact));
    else {
      const message: MessageData = {
        title: i18n.t('notifications.server-message'),
        description: i18n.t('notifications.no-logs-for-contact', {
          name: contact.name,
        }),
        type: MessageStates.WARNING,
      };
      yield put(turnMessageOn(message));
      yield put(fetchContactFailure());
    }
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(fetchContactFailure());
  }
}
